<template>
  <span :class="_class">
    <slot />
    <span
      :class="_badgeClass"
      :style="_numberStyle"
    >{{ _badgeText }}</span>
  </span>
</template>

<script>
const name = 'ten-badge';

export default {
  name,
  props: {
    /**
     * 设置 Badge 主题,当传入 color / textColor 时，theme 无效
     * @member info | success | error | warn | disabled
     */
    theme: {
      validator(type) {
        return ['info', 'success', 'error', 'warning', 'disabled'].indexOf(type) !== -1;
      },
      default: 'error',
    },
    /**
     * 是否只展示小红点，不展示数值
     */
    dot: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否设置为圆角型徽标
     */
    round: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否展示在右上角，dot 设置为 true 时默认 corner 也为 true
     */
    corner: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否禁用
     */
    disabled: Boolean,
    /**
     * 展示的最大数值，大于该数值时显示最大值且后面添加符号'+'，为 0 时隐藏
     */
    maxCount: {
      type: Number,
      default: 99,
    },
    /**
     * 展示的数值
     */
    count: Number,
    /**
     * 自定义 Badge 的内容
     */
    text: String,
    /**
     * corner 为 true 时设置位置偏移，格式为 {x, y}
     */
    offset: Object,
    /**
     * 自定义 Badge 的背景颜色
     */
    backgroundColor: String,
    /**
     * 自定义 Badge 的字体颜色
     */
    color: String,
  },
  data() {
    return {

    };
  },
  computed: {
    _class() {
      return [
        `${name}`,
        `${name}--theme-${this._theme}`,
        {
          'ten-badge--pos-corner': this._corner,
          'ten-badge--pos-normal': !this._corner,
          'ten-badge--dot': this.dot,
          'ten-badge--round': this.round,
        },
      ];
    },
    _badgeClass() {
      return [
        'ten-badge__badge',
        {
          'ten-badge__badge--dot': this.dot,
          'ten-badge__badge--round': this.round,
        },
      ];
    },
    _theme() {
      return this.disabled ? 'disabled' : this.theme;
    },
    _corner() {
      return this.dot || this.corner;
    },
    _badgeText() {
      if (this.dot) {
        return '';
      }
      let text = this.text || '';
      if (typeof this.count !== 'undefined') {
        text = `${text} ${Math.min(this.count, this.maxCount)}${this.count > this.maxCount ? '+' : ''}`;
      }
      return text.trim();
    },
    _numberStyle() {
      const style = {};

      if (this.backgroundColor) {
        style.backgroundColor = this.backgroundColor;
      }

      if (this.color) {
        style.color = this.color;
      }

      if (this._corner && this.offset) {
        style.marginLeft = `${-parseInt(this.offset.x, 10)}px`;
        style.marginTop = `${-parseInt(this.offset.y, 10)}px`;
      }

      return style;
    },
  },
};
</script>
